import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/deposit`, { params });
  },
  post(params) {
    return Vue.axios.post(`${API_HOST}/deposit`, params);
  },


};



// WEBPACK FOOTER //
// ./src/api/balance.js